import { KnowMore } from '../../../Common/buttons/know-more';
import { Accordion } from '../../../Molecules/accordion';
import { TUseCaseFoldCards } from './constants';

export const UseCaseAccordian: React.FC<{
  card: TUseCaseFoldCards;
  idx: number;
}> = ({ card, idx }) => {
  if (!card) return <></>;
  return (
    <div key={card.title} className={`useCaseAccordian w-full pb-px`}>
      <Accordion
        isExpandedState={idx === 0 ? true : false}
        className="w-full px-5 bg-white my-0"
        accordianHeaderEleClasses="py-4"
        header={
          <div className="flex items-center">
            <img className="w-10 h-10 mr-3" src={card.icon} alt="icon" />
            <p className="text-base text-font-500 font-bold">{card.title}</p>
          </div>
        }
        detailPanelClasses="block"
      >
        <p className="text-base text-font-200">{card.description}</p>
        <KnowMore
          href={'https://cleartax.in/income-tax-efiling'}
          funnelMetricLabel="use-case-fold"
          className="ml-0 py-4 block sm:pb-6"
          textClasses="text-base font-bold"
        />
      </Accordion>
    </div>
  );
};
